import {createHashHistory, createBrowserHistory} from 'history'

let history = createBrowserHistory()
export default function (state = history, action) {
    return state
}